<template>
    <div
        v-qa="'page-500'"
        class="page-500"
    >
        <ErrorFiveHundredMessage :errors="errors">
            <template #default>
                <slot name="default"></slot>
            </template>
        </ErrorFiveHundredMessage>
    </div>
</template>

<script setup lang="ts">
import { useSetStatus } from 'wucdbm-vite-vue-ssr'

import ErrorFiveHundredMessage from '@/components/ui/error/ErrorFiveHundredMessage.vue'
import type { ErrorCollectionWithTraces } from '@/helpers/errors'

defineProps<{
    errors: ErrorCollectionWithTraces
}>()

const { setStatus } = useSetStatus()
setStatus(500)
</script>

<style lang="scss" scoped>
.page-500 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10vh 0 20vh;
}
</style>
